<style lang="less" scoped>
  @import "./1px.less";

  .confirm {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }

  .b {
    position: absolute;
    width: 13.5rem;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, 50%);
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 0.5rem;
    overflow: hidden;
    font-size: 0.65rem;
    color: #404040;
  }
  .confirm.style1 .b {
    border-radius: 0;
  }

  .text {
    padding: 0.875rem;
    word-break: break-all;
    word-wrap: break-word;
    text-align: center;
    .cd-1px-b (@color: #e0e0e0)
  }

  .btn {
    line-height: 2.1rem;
    height: 2.1rem;
    font-size: 0.85rem;
    .left {
      .cd-1px-r (@color: #e0e0e0)

    }
  }

  .btn .l {
    color: #157efb;
  }

  .title {
    font-size: .8rem;
    font-weight: bold;

  }

  .show-content {
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    -webkit-align-items: center;
    align-items: center;
    min-height: 2.7rem;
    font-size: 0.7rem;
    div {
      flex-grow: 1;
    }
  }
</style>
<template>
  <transition name="fade" mode="out-in" appear>
    <div v-show="showFlag" class="confirm" :class="style">
      <div class="b">
        <div class="text">
          <div class="title f-tac f-wwb" v-html="showTitle"></div>
          <div class="show-content">
            <div class="f-tac f-wwb" v-html="showText"></div>
          </div>
        </div>
        <div class="btn flex-box">
          <a class="f-db f-tac flex1 l left" @click="cancel" v-html="option.button1"></a>
          <a class="f-db f-tac flex1 l" @click="confirm" v-html="option.button2"></a>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  //接受一个 option 对象，默认以下显示
  export default {
    data() {
      return {
        showFlag: false,
        option: {},
      };
    },
    props:['styleType'],
    computed: {
      showText: function() {
        var re = '';
        if (this.option.text) {
          this.option.text = this.option.text+''
          re = this.option.text.replace(/<script.*>/, '').replace(/<\/script>/, '');
        }
        return re;
      },
      showTitle() {
        var re = '';
        if (this.option.title) {
          this.option.title = this.option.title+''
          re = this.option.title.replace(/<script.*>/, '').replace(/<\/script>/, '');
        }
        return re;
      },
      style() {
        return 'style'+ this.styleType;
      }
    },
    methods: {
      confirm() {
        this.showFlag = false;
        if (this.option.yes) {
          this.option.yes();
          this.option.yes = null;
        }
      },
      cancel() {
        this.showFlag = false;
        if (this.option.no) {
          this.option.no();
          this.option.no = null;
        }
      },
      clean() {
        this.showFlag = false;
        this.option = {
          title: '',
          text: '',
          yes: null,
          no: null,
          button1: '取消',
          button2: '确定',
        };
      },
      show(opt) {
        this.clean();
        Object.assign(this.option, opt);
        this.showFlag = true;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/bjxy-component/confirm/confirm.vue